"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableItem = void 0;
const findGroupByKey_1 = __importDefault(require("@opsbase/lib-data-query/helpers/findGroupByKey"));
const calcUniqueKeyForViewField_1 = require("@opsbase/lib-data-viewfield/helpers/calcUniqueKeyForViewField");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useDVL_1 = __importDefault(require("@opsbase/web-dvl/useDVL"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const react_1 = __importStar(require("react"));
const DVLTableRowHeader_1 = __importDefault(require("../DVLTableRow/DVLTableRowHeader"));
const DVLTableItemCell_1 = __importDefault(require("./DVLTableItemCell"));
const DVLTableItemDeleteButton_1 = __importDefault(require("./DVLTableItemDeleteButton"));
const makeMyClasses = (rowsClickable, isHighlighted, isLast) => ({
    root: {
        flex: 0,
        position: 'relative',
        borderRadius: 4,
        paddingBottom: isLast ? 16 : undefined,
        borderBottom: `1px solid ${lib_palette_1.default.BackgroundGrey.main}`,
        borderLeft: isHighlighted
            ? `4px solid ${lib_palette_1.default.primary.main}`
            : rowsClickable
                ? `4px solid transparent`
                : undefined,
        borderRight: isHighlighted
            ? `4px solid ${lib_palette_1.default.primary.main}`
            : rowsClickable
                ? `4px solid transparent`
                : undefined,
    },
    menuCell: {
        flex: 1,
    },
});
function DVLTableItem(props) {
    const { nodeKey, item, rowIdx, isLast = false, focused = false, onFocus } = props;
    const { onItemClick, itemMenu: ItemMenu, itemDeletePage, rowsClickable, highlightedItems, } = (0, useDVL_1.default)();
    const dt = (0, useDataTree_1.default)();
    const { fields, groupBys, maxVisibleFields, pinField } = (0, useView_1.default)(dt.viewId);
    const isHighlighted = rowsClickable && !!(highlightedItems === null || highlightedItems === void 0 ? void 0 : highlightedItems.find(i => (i === null || i === void 0 ? void 0 : i.id) === (item === null || item === void 0 ? void 0 : item.id)));
    const hasFocusOnTitle = !!ItemMenu;
    const hasFocusOnRow = !!itemDeletePage;
    const isPinned = !!pinField;
    const myCss = (0, web_css_1.default)(makeMyClasses, [rowsClickable, isHighlighted, isLast]);
    const handleItemClick = (0, react_1.useCallback)(() => {
        if (rowsClickable)
            onItemClick(item);
    }, [rowsClickable, item, onItemClick]);
    const handleFocus = (0, useCallforward_1.default)(v => () => onFocus === null || onFocus === void 0 ? void 0 : onFocus(v), [onFocus]);
    const visibleFields = (0, react_1.useMemo)(() => fields
        .filter(field => !field.hidden)
        .filter(field => !(0, findGroupByKey_1.default)(groupBys, field.key.toString()))
        .slice(0, maxVisibleFields), [fields, groupBys, maxVisibleFields]);
    return (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.root }, key: (item === null || item === void 0 ? void 0 : item.id) || 'empty', onClick: rowsClickable ? handleItemClick : undefined, onMouseEnter: hasFocusOnRow ? handleFocus(true) : undefined, onMouseLeave: hasFocusOnRow ? handleFocus(false) : undefined },
            react_1.default.createElement(DVLTableRowHeader_1.default, { nodeKey: nodeKey, item: item, onMouseEnter: hasFocusOnTitle ? handleFocus(true) : undefined, onMouseLeave: hasFocusOnTitle ? handleFocus(false) : undefined },
                react_1.default.createElement(DVLTableItemCell_1.default, { className: myCss.menuCell, nodeKey: nodeKey, field: fields[0], item: item, colIdx: 0, rowIdx: rowIdx, isLastCol: visibleFields.length === 1 }),
                isPinned && (react_1.default.createElement(DVLTableItemCell_1.default, { className: myCss.menuCell, nodeKey: nodeKey, field: fields[1], item: item, colIdx: 1, rowIdx: rowIdx, isLastCol: visibleFields.length === 1 })),
                !!ItemMenu && react_1.default.createElement(ItemMenu, { expanded: true, item: item, visible: focused })),
            react_1.default.createElement(Horizontal_1.default, null, visibleFields.map((field, idx) => !(idx === 0 || (isPinned && idx === 1)) && (react_1.default.createElement(DVLTableItemCell_1.default, { key: (0, calcUniqueKeyForViewField_1.calcUniqueKeyForViewField)(field) + '.' + idx, nodeKey: nodeKey, item: item, field: field, rowIdx: rowIdx, colIdx: idx, isLastCol: idx === visibleFields.length - 1 })))),
            !!itemDeletePage && focused && react_1.default.createElement(DVLTableItemDeleteButton_1.default, { item: item })));
    }, [
        myCss,
        item,
        rowsClickable,
        handleItemClick,
        hasFocusOnRow,
        handleFocus,
        nodeKey,
        hasFocusOnTitle,
        fields,
        rowIdx,
        visibleFields,
        isPinned,
        ItemMenu,
        focused,
        itemDeletePage,
    ]);
}
exports.DVLTableItem = DVLTableItem;
exports.default = DVLTableItem;
